import React from 'react';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import Footer from 'components/footer/Footer';
import ProductProvider from 'components/app/e-commerce/ProductProvider';
import CourseProvider from 'components/app/e-learning/CourseProvider';
import useMainLayout from 'hooks/useMainLayout';
import Charging from 'components/common/Charging';
import NavbarStandard from 'components/pages/landing/NavbarStandard';

const Layout = () => {
 const { auth, isFluid, isKanban, isLoading } = useMainLayout(false);

 if (isLoading) return <Charging />;

 if (!auth?.token)
  return (
   <div className={isFluid ? 'container-fluid' : 'container'}>
    <div className={classNames('content', { 'pb-0': isKanban })}>
     <NavbarStandard />
     <Outlet />
     {!isKanban && <Footer />}
    </div>
   </div>
  );

 return (
  <div className={isFluid ? 'container-fluid' : 'container'}>
   <ProductProvider>
    <CourseProvider>
     <div className={classNames('content', { 'pb-0': isKanban })}>
      <NavbarTop />
      <Outlet />
      {!isKanban && <Footer />}
     </div>
    </CourseProvider>
   </ProductProvider>
  </div>
 );
};

export default Layout;
